module.exports = __webpack_public_path__ + "static/media/DINOT-Regular.6f42a754.woff";